<template>
  <div class="page">
    <div class="title">手机号码快捷注册</div>
    <!-- 注册表单 -->
    <van-form @submit="onSubmit" @failed="onFailed" ref="fromItemRef">
      <!-- 用户名手机号码 -->
      <van-field
        v-model="fromItem.mobile"
        placeholder="请输入您的手机号码"
        left-icon="phone-o"
        :error-message="phoneError"
        :style="phoneError ? 'margin-bottom: 12.2px' : '38.6px'"
        @input="clearError1"
        @blur="phoneBlue"
        :rules="[{ required: true, pattern: phoneReg, message: phoneError }]"
      />
      <!-- 验证码 -->
      <van-field
        v-model="fromItem.code"
        center
        maxlength="4"
        placeholder="请输入验证码"
        :error-message="codeError"
        :style="codeError ? 'margin-bottom: 12.2px' : '38.6px'"
        @input="clearError2"
        @blur="codeBlur"
        :rules="[{ required: true, pattern: codeReg, message: codeError }]"
      >
        <van-button
          :disabled="isDisabled"
          class="codeBtn"
          type="info"
          plain
          slot="button"
          size="small"
          native-type="button"
          @click="checkMobileExists"
        >
          {{
          registerCountDown.count
          ? registerCountDown.count + '秒后重试'
          : '获取验证码'
          }}
        </van-button>
      </van-field>
      <!-- 密码设置 closed-eye -->
      <van-field
        v-model="fromItem.pass_word"
        :type="isPassword"
        placeholder="请设置登录密码"
        :left-icon="icon"
        :error-message="pswError"
        :style="pswError ? 'margin-bottom: 12.2px' : '38.6px'"
        @input="clearError3"
        @blur="pswBlur"
        maxlength="32"
        :rules="[{ required: true, message: pswError }]"
      ></van-field>
      <!-- 密码切换明文显示 -->
      <div class="pswShow" @click="pswShow"></div>
      <!-- 选择所在城市 -->
      <van-field
        class="last-field"
        left-icon="location-o"
        readonly
        clickable
        :value="addressStr"
        placeholder="请选择所在城市"
        @click="showCityListOn"
        right-icon="arrow"
      />
      <van-popup v-model="showAddress" position="bottom">
        <van-area
          :area-list="areaList"
          @confirm="onConfirmAddress"
          @cancel="showAddress = false"
          :value="addressCode"
        />
      </van-popup>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">注册</van-button>
      </div>
    </van-form>
    <!-- 公共组件 底部 -->
    <bt_logo></bt_logo>
    <drag-verify ref="slideblock" :value.sync="isShowVerify" @success="onSuccess"></drag-verify>
  </div>
</template>
<script>
// 引入公共组件
import btLogo from '../components/btLogo'
import DragVerify from '../components/drag-verify'
import store from '../vuex/store'
import { getPlatFormCode, formatSeconds } from '../libs/util'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      isShowVerify: false,
      fromItem: {
        mobile: '', // 手机号码
        code: '', // 验证码
        pass_word: '', // 设置密码
        address: {
          province_id: '',
          province_name: '',
          city_id: '',
          city_name: '',
          area_id: '',
          area_name: '',
        },
        adVal: [],
        channel: 12, //来源渠道
        promotes_id: '0', // 推广id
        referrer: '', // 推广来源地址
      },
      addressStr: '', // 显示地址
      showAddress: false, // 选择地址栏
      areaList: {}, // 省市区列表
      registerCountDown: {
        count: '', // 验证码计时
        timer: null, // 定时器
      },
      phoneError: '', // 手机验证
      codeError: '', // 验证码验证
      pswError: '', // 密码验证
      phoneReg: /^1[3456789]\d{9}$/, // 手机号正则校验
      codeReg: /^[a-zA-Z0-9]{4}$/, // 验证码正则校验
      isPassword: 'password', // 密码的显示类型
      icon: 'closed-eye',
      isDisabled: false,
      allAreaData: {}, // 全部地址
      addressCode: '',
      isLogin: false, // 注册放重复
    }
  },
  async created() {
    // 获取平台信息
    let platformcode = getPlatFormCode()
    //this.getRegions();
    // 没有平台信息
    if (!platformcode) {
      store.dispatch('getPlatform').then((platform) => {})
    }
    // 获取省份列表
    await this.getCityList()
    this.getLocation() // 调用获取地理位置
    // 获取推广id和推广来源地址
    let paramsStr = window.location.search
    let arr = paramsStr.slice(1, paramsStr.length).split('&')
    if (paramsStr.indexOf('spid') != -1) {
      let resulve = []
      arr.forEach((item) => {
        resulve.push(item.split('='))
      })
      let res = []
      resulve.forEach((v, t) => {
        v.forEach((item) => {
          if (item == 'spid' && resulve[t][1] > 0) {
            this.fromItem.promotes_id = resulve[t][1]
          }
        })
      })
    } else {
      this.fromItem.promotes_id = '0'
    }
    if (paramsStr.indexOf('reffer') != -1) {
      let resulve = []
      arr.forEach((item) => {
        resulve.push(item.split('='))
      })
      let res = []
      resulve.forEach((v, t) => {
        v.forEach((item) => {
          if (item == 'reffer' && resulve[t][1] != 'undefined') {
            this.fromItem.referrer = resulve[t][1]
          }
        })
      })
    } else {
      this.fromItem.referrer = ''
    }

    // // 推广id
    // if(this.$store.state.loginParams.spid) {
    //   this.fromItem.promotes_id = this.$store.state.loginParams.spid
    // }
    // // 推广来源地址
    // if(this.$store.state.loginParams.reffer) {
    //   this.fromItem.referrer = this.$store.state.loginParams.reffer
    // }
    console.log(this.fromItem, 'this.fromItem')
  },
  methods: {
    onSuccess(ticket) {
      console.log(ticket, '------ticket')
    },
    showCityListOn() {
      // 打开弹框
      this.showAddress = true
    },
    //得到所有的省市区列表
    async getCityList(provinceId) {
      return this.$api.getregions().then((res) => {
        if (res.code !== 200) {
          return Toast.fail('获取省市区列表失败')
        }
        let areaList = {
          province_list: {},
          city_list: {},
          county_list: {},
        }
        this.allAreaData = res.response
        console.log(this.allAreaData, '地址')
        this.allAreaData.provinces.forEach((val) => {
          areaList.province_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 省
        this.allAreaData.citys.forEach((val) => {
          areaList.city_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 市
        this.allAreaData.districts.forEach((val) => {
          areaList.county_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 区
        this.areaList = areaList
      })
    },
    // 选择店铺地址
    onConfirmAddress(value) {
      console.log(value)
      let addressName = []
      let addressNameId = []
      let addressNameItem = ''
      let addressNameItemId = ''
      value.forEach((item) => {
        addressNameItem = item.name.split('<')[0]
        addressName.push(addressNameItem)
        addressNameItemId = item.name.split('-')[1].split('^')[0]
        addressNameId.push(addressNameItemId)
      })
      // 选择城市名称
      this.fromItem.address.province_name = addressName[0]
      this.fromItem.address.city_name = addressName[1]
      this.fromItem.address.area_name = addressName[2]
      // 选择城市id
      this.fromItem.address.province_id = addressNameId[0]
      this.fromItem.address.city_id = addressNameId[1]
      this.fromItem.address.area_id = addressNameId[2]
      this.fromItem.adVal = addressNameId
      console.log(addressName)
      console.log(addressNameId)
      this.address1 = addressName
      this.addressStr = addressName.join(' / ')
      this.addressId = addressNameId
      this.showAddress = false
    },
    /*   // 登录凭证
    test() {
      this.$cookie.set(
        'token',
        'h5W6z5%2bwywUVnpb7qUmLWTo1teL0OvvNkQUBLdbSzsWuj9NR9edZkN%2fCpK9BTkYgBDHPRmBAUuu7t7vMa9anK4McuaCS%2fnyrxYPnqhP1pfL%2bjFQJmt%2fn2bNgY33GYRaSoY5fXPLiWu2CkkBXsmmQGajcs6Mvf2TM%2fOC%2bpzUDzuldsnrCmv2IS2%2fiEUMX2RyH',
        {
          expires: 7
        }
      )
      this.$store.commit('tokenToVuex')
      this.getUserInfo()
    }, */
    // 获取验证码
    checkMobileExists() {
      let _this = this
      if (_this.fromItem.mobile == '') {
        return Toast('请输入手机号码')
      }

      // 测试
      // return this.test()
      this.isDisabled = true
      _this.$api
        .checkMobileExists({
          mobile: _this.fromItem.mobile,
        })
        .then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.$api
              .sendCode({
                mobile: _this.fromItem.mobile,
                code_type: 5,
              })
              .then((res) => {
                console.log(res)
                if (res.code == '200') {
                  // _this.$Message.success('发送成功');
                  Toast.success('发送成功')
                } else {
                  // _this.$Message.error('发送失败');
                  Toast(res.msg)
                }
              })

            //  _this.phoneError = res.msg
            // 倒计时...
            // this.isDisabled = true
            const TIME_COUNT = 60
            _this.registerCountDown.count = TIME_COUNT

            // _this.registerCountDown.show = false;

            _this.registerCountDown.timer = setInterval(() => {
              if (
                _this.registerCountDown.count > 0 &&
                _this.registerCountDown.count <= TIME_COUNT
              ) {
                _this.registerCountDown.count--
              } else {
                // _this.registerCountDown.show = true;
                this.isDisabled = false
                _this.yzmType = true

                clearInterval(_this.registerCountDown.timer)

                _this.registerCountDown.timer = null
              }
            }, 1000)
          } else if (res.code == 201) {
            this.isDisabled = false
            _this.phoneError = ''
            return Dialog.confirm({
              title: '该手机号已被注册',
              message:
                '【推荐】使用电脑打开 panel.deiyoudian.com登录您的帐号即可上架商品做营销活动\n应用商店搜索 “得有店” APP下载客户端进行 管理店铺\n在使用过程中，有任何问题可联系专属客服一对 一为您解答',
              messageAlign: 'left',
              showCancelButton: false,
            })
          } else {
            this.isDisabled = false
            Toast(res.msg)
          }
        })
    },
    // 手机号验证
    phoneBlue(e) {
      let pR = /^1[3456789]\d{9}$/
      let _this = this
      if (e.target.value.trim() == '') {
        // Toast.fail('店铺名称不能为空')
        return (_this.phoneError = '手机号不能为空')
      }
      if (!pR.test(e.target.value)) {
        return (_this.phoneError = '请输入正确的手机号')
      }
      _this.$api
        .checkMobileExists({
          mobile: _this.fromItem.mobile,
        })
        .then((res) => {
          // console.log(res)
          if (res.code !== 200) {
            Dialog.confirm({
              title: '该手机号已被注册',
              message:
                '【推荐】使用电脑打开 panel.deiyoudian.com登录您的帐号即可上架商品做营销活动\n应用商店搜索 “得有店” APP下载客户端进行 管理店铺\n在使用过程中，有任何问题可联系专属客服一对 一为您解答',
              messageAlign: 'left',
              showCancelButton: false,
            })
            return (_this.phoneError = res.msg)
          }
        })
    },
    // 验证码验证
    codeBlur(e) {
      let cR = /^[a-zA-Z0-9]{4}$/
      if (e.target.value.trim() == '') {
        return (this.codeError = '请输入验证码')
      }
      if (!cR.test(e.target.value)) {
        return (this.codeError = '验证码格式输入错误')
      }
    },
    // 密码验证
    pswBlur(e) {
      if (e.target.value.trim() == '') {
        return (this.pswError = '请输入密码')
      }
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo)
      this.onSubmit()
    },
    // 注册
    onSubmit(values) {
      // this.isShowVerify = true
      // this.$refs.fromItemRef.validate(this.fromItem.mobile).then((res) => {
      //   console.log(res)
      // })
      // return console.log(123, '验证通过了')
      let _this = this
      if (_this.fromItem.mobile == '') {
        return Toast('手机号码不能为空')
      }
      let pR = /^1[3456789]\d{9}$/
      if (!pR.test(_this.fromItem.mobile)) {
        return (_this.phoneError = '请输入正确的手机号')
      }
      if (_this.phoneError) {
        // Toast(_this.phoneError)
        return Dialog.confirm({
          title: '该手机号已被注册',
          message:
            '【推荐】使用电脑打开 panel.deiyoudian.com登录您的帐号即可上架商品做营销活动\n应用商店搜索 “得有店” APP下载客户端进行 管理店铺\n在使用过程中，有任何问题可联系专属客服一对 一为您解答',
          messageAlign: 'left',
          showCancelButton: false,
        })
      }
      if (_this.fromItem.code == '') {
        return Toast('请输入验证码')
      }
      if (_this.fromItem.pass_word == '') {
        return Toast('请输入密码')
      }
      if (_this.addressStr == '') {
        return Toast('请选择所在城市')
      }
      if(!_this.isLogin) {
        _this.isLogin = true
        _this.$api.usersRegister(_this.fromItem).then((res) => {
          _this.isLogin = false
          if (res.code != 200) return Toast(res.msg)
          if (res.response.success) {
            _this.$cookie.set('token', res.response.token, { expires: 7 })
            _this.$store.commit('tokenToVuex')
            _this.getUserInfo()
          }
        })
      }
    },

    clearError1(e) {
      if (this.phoneError && e != '') {
        this.phoneError = ''
      }
    },
    clearError2(e) {
      if (this.codeError && e != '') {
        this.codeError = ''
      }
    },
    clearError3(e) {
      if (this.pswError && e != '') {
        this.pswError = ''
      }
    },
    // 注册成功后获取用户信息
    getUserInfo(isRegister) {
      let _this = this
      // 获取用户信息
      this.$api.getUserInfo().then(function (res) {
        if (res.code != '200') {
          return Toast.fail('获取用户信息失败')
        }
        _this.$cookie.set('user', JSON.stringify(res.response), {
          expires: 7,
        })
        _this.$store.commit('userToVuex')
        if (res.response.has_password) {
          if (res.response.has_agent_address) {
            // Dialog.confirm({
            //   title: '该手机号已被注册',
            //   message: '【推荐】使用电脑打开 panel.deiyoudian.com登录您的帐号即可上架商品做营销活动\n应用商店搜索 “得有店” APP下载客户端进行 管理店铺\n在使用过程中，有任何问题可联系专属客服一对 一为您解答',
            //   messageAlign: 'left',
            //   showCancelButton: false
            // })
            // 测试
            Toast.success('登录成功')
            _this.$router.push({
              name: 'createShop',
            })
          }
        }
      })
    },
    // 密码切换显示
    pswShow() {
      if (this.isPassword == 'password') {
        this.isPassword = 'text'
        this.icon = 'eye-o'
        return false
      }
      this.isPassword = 'password'
      this.icon = 'closed-eye'
    },
    /**获取地图定位*/
    getLocation() {
      const that = this
      let map = new AMap.Map('contaner')
      AMap.plugin('AMap.Geolocation', function () {
        // map.addControl(new AMap.Geolocation())
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, //显示定位按钮，默认：true
          buttonPosition: 'LB', //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: false, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: false, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
        map.addControl(geolocation)
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', onComplete) // 用户允许使用当前地址
        AMap.event.addListener(geolocation, 'error', onError) // 用户拒绝
        // 用户允许获取当前位置
        function onComplete(data) {
          // data是具体的定位信息
          console.log(data)
          // 省
          that.province = data.addressComponent.province
          // 市
          that.city = data.addressComponent.city
          // 区
          that.district = data.addressComponent.district
          console.log('that.province', that.province)
          console.log('that.city', that.city)
          console.log('that.district', that.district)
          if (that.province != '' && that.city != '' && that.district != '') {
            if (that.allAreaData) {
              // 根据获取的省份筛选
              let p = that.allAreaData.provinces.filter(
                (item) => that.province == item.title
              )
              // 根据获取的市名筛选
              let c = that.allAreaData.citys.filter(
                (item) => that.city == item.title
              )
              // 根据获取的区名筛选
              let d = that.allAreaData.districts.filter(
                (item) => that.district == item.title
              )
              // 当前定位省市区的code
              that.codeP = p[0].unique
              that.codeC = c[0].unique
              that.codeD = d[0].unique
              // console.log(that.codeP, that.codeC, that.codeD)
              // 选择城市名称
              that.fromItem.address.province_name = p[0].title
              that.fromItem.address.city_name = c[0].title
              that.fromItem.address.area_name = d[0].title
              // 选择城市id
              that.fromItem.address.province_id = p[0].id
              that.fromItem.address.city_id = c[0].id
              that.fromItem.address.area_id = d[0].id
              that.fromItem.adVal = [p[0].id, c[0].id, d[0].id]
              that.addressStr = [that.province, that.city, that.district].join(
                ' / '
              )
              that.addressCode = that.codeD
              // that.positionPCD = true
            }
            // })
          }
        }
        function onError(data) {
          // 定位出错
          console.log(data)
        }
      })
    },
  },
  components: {
    bt_logo: btLogo,
    DragVerify,
  },
}
</script>
<style lang="css" scoped>
.page {
  height: 100%;
  padding: 62px 37px 0 36px;
  box-sizing: border-box;
}
.title {
  margin: 0 0 70px 0;
  font-size: 23px;
  color: #333;
}
.van-button--info {
  color: #fff;
  background-color: #3d6eff;
  border: 0.02667rem solid #3d6eff;
}
.codeBtn {
  border: none;
  color: #3d6eff !important;
  background-color: transparent;
}
/* 输入框的字体大小 */
/* .van-field__control {
  padding: 5px 16px;
} */
.van-field {
  margin-bottom: 35px;
  padding: 5px 0;
}
/* icon 图标样式 */
.van-icon {
  margin-right: 5px;
}

.van-form {
  position: relative;
}
/* 密码明文显示 */
.pswShow {
  position: absolute;
  left: 0;
  top: 153px;
  width: 20px;
  height: 20px;
  background-color: transparent;
  /* transparent */
}
.van-field__error-message {
  font-size: 16px;
}
</style>
